import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.947 3.413A.67.67 0 0 0 12.333 3H5.667a.667.667 0 0 0 0 1.333h5.06L3.193 11.86a.667.667 0 0 0 .217 1.093.67.67 0 0 0 .73-.146l7.527-7.534v5.06a.667.667 0 0 0 1.333 0V3.667a.7.7 0 0 0-.053-.254"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })